import colors from '@styles/common/colors';
import devices from '@styles/common/devices';
import sizes from '@styles/common/sizes';
import typography from '@styles/common/typography';
import styled from 'styled-components';

export const LabelWithAsterisk = styled.label`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  font-family: ${typography.fonts.body};
  font-size: ${sizes.md};
  color: ${colors.text_grey};

  &::after {
    content: ' *';
    color: ${colors.red};
  }

  @media ${devices.tablet} {
    font-size: ${sizes.lg};
  }
`;
